/**
 * 中文填空题
 */
import QuestionFillinchinese from './view';

export default QuestionFillinchinese;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/fillinchinese/index.js